import * as React from "react";
import { 
  BaseEdge, 
  EdgeProps, 
  getBezierPath, 
  EdgeLabelRenderer,
  useReactFlow 
} from "@xyflow/react";
import { Trash2 } from "lucide-react";

export function CustomEdge({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  style = {},
  markerEnd,
  selected,
}: EdgeProps): React.ReactNode {
  const { deleteElements } = useReactFlow();
  const [edgePath, labelX, labelY] = getBezierPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
  });

  const onEdgeClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    deleteElements({ edges: [{ id }] });
  };

  return (
    <>
      <BaseEdge 
        path={edgePath} 
        markerEnd={markerEnd} 
        style={{
          ...style,
          strokeWidth: selected ? 2 : 1,
          stroke: selected ? '#3b82f6' : (style.stroke || '#cbd5e1'),
          transition: 'all 0.2s',
        }} 
      />
      
      <EdgeLabelRenderer>
        {selected && (
          <div
            style={{
              position: 'absolute',
              transform: `translate(-50%, -50%) translate(${labelX}px,${labelY}px)`,
              pointerEvents: 'all',
            }}
            className="nodrag nopan"
          >
            <button
              onClick={onEdgeClick}
              className="flex h-7 w-7 items-center justify-center rounded-full border border-border bg-card text-muted-foreground shadow-xl transition-all hover:bg-destructive/10 hover:text-destructive hover:border-destructive/30 active:scale-90"
              title="Delete edge"
            >
              <Trash2 className="h-3.5 w-3.5" />
            </button>
          </div>
        )}
      </EdgeLabelRenderer>
    </>
  );
}
